module.exports = __webpack_public_path__ + "img/shared-1.bc8ed541.jpg";